import { render } from "./Home.vue?vue&type=template&id=e87c4b40"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\EFRENBP\\Desktop\\Projects\\2022\\03-Landing referidos\\AM-referidos\\am-referrals router\\am-referrals\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__